import React from 'react';

const VaanOurProjectsStyles = ({ colors }) => {
  return (
    <style>{`
      /* Your existing animation styles remain the same */
      @keyframes vaanourproject-slideInLeft {
        from {
          opacity: 0;
          transform: translateX(-80px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
      
      @keyframes vaanourproject-slideInRight {
        from {
          opacity: 0;
          transform: translateX(80px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
      
      @keyframes vaanourproject-slideUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      @keyframes vaanourproject-fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes vaanourproject-popup-appear {
        from {
          opacity: 0;
          transform: scale(0.8) translateY(-20px);
        }
        to {
          opacity: 1;
          transform: scale(1) translateY(0);
        }
      }

      /* Your existing container styles remain the same */
      .vaanourproject-container {
        background: ${colors?.bodyBlack || '#1A1A1A'};
        min-height: 100vh;
        padding: 60px 0;
      }
      
      .vaanourproject-header {
        text-align: center;
        margin-bottom: 50px;
      }
      
      .vaanourproject-badges {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 5px;
      }
      
      .vaanourproject-title {
        font-size: 42px;
        font-weight: 700;
        color: ${colors?.white || '#FFFFFF'};
        animation: vaanourproject-slideUp 0.8s ease 0.2s forwards;
        opacity: 0;
      }
      
      .vaanourproject-subtitle {
        font-size: 16px;
        color: ${colors?.white || '#848484'};
        max-width: 650px;
        margin: 0 auto;
        animation: vaanourproject-slideUp 0.8s ease 0.4s forwards;
        opacity: 0.2;
      }
      
      .vaanourproject-grid {
        /* Grid styles are handled by Bootstrap classes */
      }
      
      .vaanourproject-col {
        /* Column styles are handled by Bootstrap classes */
      }
      
      .vaanourproject-card {
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 3px 15px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease;
        height: 100%;
        display: flex;
        flex-direction: column;
        opacity: 0;
        transform: translateX(-80px);
      }
      
      .vaanourproject-card.vaanourproject-slide-right {
        transform: translateX(80px);
      }
      
      .vaanourproject-card.vaanourproject-visible {
        animation-duration: 0.7s;
        animation-fill-mode: forwards;
        animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      }
      
      .vaanourproject-card.vaanourproject-visible.vaanourproject-slide-left {
        animation-name: vaanourproject-slideInLeft;
      }
      
      .vaanourproject-card.vaanourproject-visible.vaanourproject-slide-right {
        animation-name: vaanourproject-slideInRight;
      }
      
      .vaanourproject-card:hover {
        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.5);
        transform: translateY(-5px);
      }
      
      .vaanourproject-image-wrapper {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
        background: ${colors?.white || '#FFFFFF'}; /* Default white background */
      }
      
      /* Special background class - color will be applied via inline style */
      .vaanourproject-image-wrapper.vaanourproject-special-bg {
        /* Background color will be applied dynamically via inline style */
      }
      
      .vaanourproject-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        transition: transform 0.3s ease;
      }
      
      .vaanourproject-card:hover .vaanourproject-image {
        transform: scale(1.05);
      }
      
      .vaanourproject-location-badge {
        background: ${colors?.primaryTransparent || 'rgba(229, 118, 39, 0.1)'};
        color: ${colors?.primary || '#E57627'};
        backdrop-filter: blur(8px);
        padding: 5px 12px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        opacity: 0;
        z-index: 2;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 6px;
      }
      
      .vaanourproject-card.vaanourproject-visible .vaanourproject-location-badge {
        animation: vaanourproject-fadeIn 0.5s ease 0.4s forwards;
      }
      
      .vaanourproject-content {
        background: ${colors?.cardBgBlack || '#242424'};
        padding: 20px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        position: relative;
      }
      
      .vaanourproject-category-badge {
        display: inline-block;
        background: ${colors?.primaryTransparent || 'rgba(229, 118, 39, 0.1)'};
        color: ${colors?.primary || '#E57627'};
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 600;
        opacity: 0;
        margin: 0;
      }
      
      .vaanourproject-card.vaanourproject-visible .vaanourproject-category-badge {
        animation: vaanourproject-slideUp 0.5s ease 0.3s forwards;
      }
      
      .vaanourproject-card-title {
        color: ${colors?.white || '#FFFFFF'};
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 10px;
        text-transform: capitalize;
        opacity: 1;
        line-height: 1.3;
        min-height: 2.6em;
        display: flex;
        align-items: center;
      }

      .vaanourproject-card.vaanourproject-visible .vaanourproject-card-title {
        animation: vaanourproject-slideUp 0.5s ease 0.4s forwards;
      }
      
      .vaanourproject-card.vaanourproject-visible .vaanourproject-location-badge,
      .vaanourproject-card.vaanourproject-visible .vaanourproject-category-badge {
        animation: vaanourproject-slideUp 0.5s ease 0.3s forwards;
      }
      
      .vaanourproject-description {
        color: ${colors?.gray || '#FFFFFF'};
        font-size: 13px;
        margin-bottom: 50px;
        flex-grow: 1;
        line-height: 1.5;
        opacity: 0.8;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      
      .vaanourproject-card.vaanourproject-visible .vaanourproject-description {
        animation: vaanourproject-slideUp 0.5s ease 0.5s forwards;
      }
      
      .vaanourproject-visit-btn {
        background: ${colors?.primary || '#E57627'};
        color: ${colors?.white || '#FFFFFF'};
        border: none;
        padding: 10px 20px;
        border-radius: 25px;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 0.5px;
        transition: all 0.3s ease;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        text-transform: uppercase;
        opacity: 0;
        cursor: pointer;
        position: absolute;
        bottom: 20px;
        right: 20px;
        width: auto;
      }
      
      .vaanourproject-visit-btn.vaanourproject-readmore-btn {
        background: ${colors?.primary || '#4A90E2'};
      }
      
      .vaanourproject-visit-btn.vaanourproject-readmore-btn:hover {
        background: ${colors?.primaryHover || '#357ABD'};
        box-shadow:  ${colors?.primaryHover || '#357ABD'};
      }
      
      .vaanourproject-card.vaanourproject-visible .vaanourproject-visit-btn {
        animation: vaanourproject-slideUp 0.5s ease 0.6s forwards;
      }
      
      .vaanourproject-visit-btn:hover {
        background: ${colors?.primaryHover || '#D16A23'};
        transform: translateY(-2px);
        box-shadow: 0 4px 15px ${colors?.primaryTransparent || 'rgba(229, 118, 39, 0.4)'};
      }
      
      .vaanourproject-visit-btn svg {
        transition: transform 0.3s ease;
      }
      
      .vaanourproject-visit-btn:hover svg {
        transform: translateX(4px);
      }
      
      /* Popup Styles */
      .vaanourproject-popup-overlay {
        position: fixed;
        top: -25px;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(2px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        animation: vaanourproject-fadeIn 0.3s ease;
        padding: 20px;
      }
      
      .vaanourproject-popup-content {
        background: ${colors?.cardBgBlack || '#242424'};
        border-radius: 16px;
        max-width: 500px;
        width: 100%;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
        animation: vaanourproject-popup-appear 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        overflow: hidden;
      }
      
      .vaanourproject-popup-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 24px 24px 0;
        margin-bottom: 16px;
      }
      
      .vaanourproject-popup-title {
        color: ${colors?.white || '#FFFFFF'};
        font-size: 20px;
        font-weight: 700;
        margin: 0;
      }
      
      .vaanourproject-popup-close {
        background: none;
        border: none;
        color: ${colors?.gray || '#848484'};
        cursor: pointer;
        padding: 8px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .vaanourproject-popup-close:hover {
        background: rgba(255, 255, 255, 0.1);
        color: ${colors?.white || '#FFFFFF'};
      }
      
      .vaanourproject-popup-body {
        padding: 0 24px 24px;
        text-align: center;
      }
      
      .vaanourproject-popup-icon {
        color: ${colors?.primary || '#E57627'};
        margin-bottom: 20px;
      }
      
      .vaanourproject-popup-subtitle {
        color: ${colors?.white || '#FFFFFF'};
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 16px;
      }
      
      .vaanourproject-popup-message {
        color: ${colors?.gray || '#B0B0B0'};
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 20px;
      }
      
      .vaanourproject-popup-features {
        text-align: left;
        margin-bottom: 20px;
      }
      
      .vaanourproject-popup-feature {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
        color: ${colors?.gray || '#B0B0B0'};
        font-size: 14px;
      }
      
      .vaanourproject-popup-feature svg {
        color: ${colors?.primary || '#E57627'};
        flex-shrink: 0;
      }
      
      .vaanourproject-popup-contact {
        color: ${colors?.gray || '#B0B0B0'};
        font-size: 13px;
        font-style: italic;
        margin-bottom: 0;
      }
      
      .vaanourproject-popup-footer {
        padding: 16px 24px 24px;
        text-align: center;
      }
      
      .vaanourproject-popup-understand-btn {
        background: ${colors?.primary || '#E57627'};
        color: ${colors?.white || '#FFFFFF'};
        border: none;
        padding: 12px 32px;
        border-radius: 25px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      
      .vaanourproject-popup-understand-btn:hover {
        background: ${colors?.primaryHover || '#D16A23'};
        transform: translateY(-2px);
        box-shadow: 0 4px 15px ${colors?.primaryTransparent || 'rgba(229, 118, 39, 0.4)'};
      }
      
      .vaanourproject-empty {
        /* Empty state styles */
      }
      
      @media (max-width: 768px) {
        .vaanourproject-title {
          font-size: 32px;
        }
        
        .vaanourproject-subtitle {
          font-size: 14px;
        }
        
        .vaanourproject-image-wrapper {
          height: 160px;
        }
        
        .vaanourproject-content {
          padding: 16px;
        }
        
        .vaanourproject-card-title {
          font-size: 16px;
        }
        
        .vaanourproject-description {
          font-size: 12px;
          margin-bottom: 45px;
        }
        
        .vaanourproject-visit-btn {
          bottom: 16px;
          right: 16px;
          padding: 8px 16px;
          font-size: 11px;
        }
        
        .vaanourproject-popup-content {
          margin: 20px;
        }
        
        .vaanourproject-popup-header {
          padding: 20px 20px 0;
        }
        
        .vaanourproject-popup-body {
          padding: 0 20px 20px;
        }
        
        .vaanourproject-popup-footer {
          padding: 16px 20px 20px;
        }
      }
    `}</style>
  );
};

export default VaanOurProjectsStyles;